// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/* @todo: refactor this class name, and component: \`sprite-selector\` to \`sprite\` */

.sprite-selector-item_sprite-selector-item__34DE {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.8rem;
    color: var(--text-primary);
    border-width: 2px;
    border-style: solid;
    border-color: var(--ui-black-transparent);
    border-radius: 0.5rem;

    text-align: center;
    cursor: pointer;

    -webkit-user-select: none;

       -moz-user-select: none;

        -ms-user-select: none;

            user-select: none;
}

.sprite-selector-item_sprite-selector-item__34DE.sprite-selector-item_is-selected_bWv8I {
    box-shadow: 0px 0px 0px 4px var(--looks-transparent);
    border: 2px solid var(--looks-secondary);
    background: var(--ui-white);
}

.sprite-selector-item_sprite-selector-item__34DE:hover {
    border: 2px solid var(--looks-secondary);
    background: var(--ui-white);
}

.sprite-selector-item_sprite-selector-item__34DE:hover .sprite-selector-item_sprite-image_JtM1V, .sprite-selector-item_is-selected_bWv8I .sprite-selector-item_sprite-image_JtM1V {
    filter: drop-shadow(0px 0px 2px  var(--ui-black-transparent));
}

/* Outer/Inner chicanery is to prevent layouts when sprite image changes */

.sprite-selector-item_sprite-image-outer_g_CNY {
    position: relative;
    width: 100%;
    height: 100%;
    transform: translateZ(0);
}

.sprite-selector-item_sprite-image-inner_IkPeL {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sprite-selector-item_sprite-image_JtM1V {
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    pointer-events: none;
    max-width: 32px;
    max-height: 32px;
}

.sprite-selector-item_sprite-info_zm_8Q {
    padding: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;

    font-size: 0.625rem;
    color: var(--text-primary);
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.sprite-selector-item_sprite-name_bNKBp, .sprite-selector-item_sprite-details_NTWgc {
    /*
        For truncating overflowing text gracefully
        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text
    */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.sprite-selector-item_sprite-details_NTWgc {
    margin-top: 0.125rem;
    font-size: 0.5rem;
}

.sprite-selector-item_is-selected_bWv8I .sprite-selector-item_sprite-info_zm_8Q {
    background: var(--looks-secondary);
    color: #ffffff;
}

.sprite-selector-item_delete-button_NcelK {
    position: absolute;
    top: -.625rem;
    z-index: auto;
}

[dir="ltr"] .sprite-selector-item_delete-button_NcelK {
    right: -.625rem;
}

[dir="rtl"] .sprite-selector-item_delete-button_NcelK {
    left: -.625rem;
}

.sprite-selector-item_number_jICEE {
    position: absolute;
    top: 0.15rem;
    font-size: 0.625rem;
    font-weight: bold;
    z-index: 2;
}

[dir="ltr"] .sprite-selector-item_number_jICEE {
    left: 0.15rem;
}

[dir="rtl"] .sprite-selector-item_number_jICEE {
    right: 0.15rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/sprite-selector-item/sprite-selector-item.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C,kFAAkF;;AAElF;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;;IAElB,2DAA2D;IAC3D,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,qBAAqB;;IAErB,kBAAkB;IAClB,eAAe;;IAEf,yBAAyB;;OAEtB,sBAAsB;;QAErB,qBAAqB;;YAEjB,iBAAiB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;AACjE;;AAEA,0EAA0E;;AAE1E;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mCAAmC;;IAEnC,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI;;;KAGC;IACD,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/* @todo: refactor this class name, and component: `sprite-selector` to `sprite` */\n\n.sprite-selector-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    position: relative;\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.8rem;\n    color: var(--text-primary);\n    border-width: 2px;\n    border-style: solid;\n    border-color: var(--ui-black-transparent);\n    border-radius: 0.5rem;\n\n    text-align: center;\n    cursor: pointer;\n\n    -webkit-user-select: none;\n\n       -moz-user-select: none;\n\n        -ms-user-select: none;\n\n            user-select: none;\n}\n\n.sprite-selector-item.is-selected {\n    box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n    border: 2px solid var(--looks-secondary);\n    background: var(--ui-white);\n}\n\n.sprite-selector-item:hover {\n    border: 2px solid var(--looks-secondary);\n    background: var(--ui-white);\n}\n\n.sprite-selector-item:hover .sprite-image, .is-selected .sprite-image {\n    filter: drop-shadow(0px 0px 2px  var(--ui-black-transparent));\n}\n\n/* Outer/Inner chicanery is to prevent layouts when sprite image changes */\n\n.sprite-image-outer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    transform: translateZ(0);\n}\n\n.sprite-image-inner {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sprite-image {\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    pointer-events: none;\n    max-width: 32px;\n    max-height: 32px;\n}\n\n.sprite-info {\n    padding: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n\n    font-size: 0.625rem;\n    color: var(--text-primary);\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.sprite-name, .sprite-details {\n    /*\n        For truncating overflowing text gracefully\n        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text\n    */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n.sprite-details {\n    margin-top: 0.125rem;\n    font-size: 0.5rem;\n}\n\n.is-selected .sprite-info {\n    background: var(--looks-secondary);\n    color: #ffffff;\n}\n\n.delete-button {\n    position: absolute;\n    top: -.625rem;\n    z-index: auto;\n}\n\n[dir=\"ltr\"] .delete-button {\n    right: -.625rem;\n}\n\n[dir=\"rtl\"] .delete-button {\n    left: -.625rem;\n}\n\n.number {\n    position: absolute;\n    top: 0.15rem;\n    font-size: 0.625rem;\n    font-weight: bold;\n    z-index: 2;\n}\n\n[dir=\"ltr\"] .number {\n    left: 0.15rem;\n}\n\n[dir=\"rtl\"] .number {\n    right: 0.15rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sprite-selector-item": `sprite-selector-item_sprite-selector-item__34DE`,
	"spriteSelectorItem": `sprite-selector-item_sprite-selector-item__34DE`,
	"is-selected": `sprite-selector-item_is-selected_bWv8I`,
	"isSelected": `sprite-selector-item_is-selected_bWv8I`,
	"sprite-image": `sprite-selector-item_sprite-image_JtM1V`,
	"spriteImage": `sprite-selector-item_sprite-image_JtM1V`,
	"sprite-image-outer": `sprite-selector-item_sprite-image-outer_g_CNY`,
	"spriteImageOuter": `sprite-selector-item_sprite-image-outer_g_CNY`,
	"sprite-image-inner": `sprite-selector-item_sprite-image-inner_IkPeL`,
	"spriteImageInner": `sprite-selector-item_sprite-image-inner_IkPeL`,
	"sprite-info": `sprite-selector-item_sprite-info_zm_8Q`,
	"spriteInfo": `sprite-selector-item_sprite-info_zm_8Q`,
	"sprite-name": `sprite-selector-item_sprite-name_bNKBp`,
	"spriteName": `sprite-selector-item_sprite-name_bNKBp`,
	"sprite-details": `sprite-selector-item_sprite-details_NTWgc`,
	"spriteDetails": `sprite-selector-item_sprite-details_NTWgc`,
	"delete-button": `sprite-selector-item_delete-button_NcelK`,
	"deleteButton": `sprite-selector-item_delete-button_NcelK`,
	"number": `sprite-selector-item_number_jICEE`
};
export default ___CSS_LOADER_EXPORT___;
